// Ready-made receipt "looks" the owner can apply in one tap. Each template is a
// bundle of receipt settings (apply) plus a light visual style descriptor that
// both the Settings preview and the printed invoice consume. Presentation only.

export const RECEIPT_TEMPLATES = [
  {
    id: 'classic',
    name: 'Classic',
    desc: 'Centered brand, clean solid lines, accent total',
    apply: { paper_width: '80mm', accent_totals: true, show_logo: true, show_gst_line: true },
    style: { brandAlign: 'center', divider: 'solid', totalStyle: 'accent', mono: false, brandSize: 'lg' },
  },
  {
    id: 'minimal',
    name: 'Minimal',
    desc: 'Understated, left-aligned, no logo, plain total',
    apply: { paper_width: '80mm', accent_totals: false, show_logo: false, show_gst_line: true },
    style: { brandAlign: 'left', divider: 'solid', totalStyle: 'plain', mono: false, brandSize: 'md' },
  },
  {
    id: 'bold',
    name: 'Bold',
    desc: 'Big brand with a boxed, high-impact total',
    apply: { paper_width: '80mm', accent_totals: true, show_logo: true, show_gst_line: true },
    style: { brandAlign: 'center', divider: 'solid', totalStyle: 'boxed', mono: false, brandSize: 'xl' },
  },
  {
    id: 'thermal',
    name: 'Thermal',
    desc: 'Compact 58mm, dashed lines, mono figures',
    apply: { paper_width: '58mm', accent_totals: false, show_logo: true, show_gst_line: true },
    style: { brandAlign: 'center', divider: 'dashed', totalStyle: 'plain', mono: true, brandSize: 'md' },
  },
];

export const templateById = (id) => RECEIPT_TEMPLATES.find((t) => t.id === id) || RECEIPT_TEMPLATES[0];
export const templateStyle = (id) => templateById(id).style;
